import { getAppProps } from '@/Navigation';
import { Platform } from 'react-native';
import URI from 'urijs';

export type Env = 'prt' | 'staging' | 'dev' | 'prod';

// 通过检测url的域名判断环境
function getEnvByUrl(url: string): Env {
    if (
        url.startsWith('https://m-shop-krn.prt.kuaishou.com') ||
        url.startsWith('https://m-shop.prt.kuaishou.com') ||
        url.startsWith('https://api-oversea-prt.test.gifshow.com')
    ) {
        return 'prt';
    } else if (url.startsWith('https://m-shop-krn.staging.kuaishou.com') || url.startsWith('https://m-shop.staging.kuaishou.com')) {
        return 'staging';
    } else if (url.startsWith('http://0.0.0.0') || url.startsWith('http://localhost')) {
        return 'dev'; // getQuery返回默认prod的，本地调试需要在这里直接返回
    } else {
        // 其他域名，包括AZ域名，返回prod
        return 'prod';
    }
}

// 获取当前环境
export function getEnv(): Env {
    if (Platform.OS === 'web') {
        // H5：根据域名来判断
        return getEnvByUrl(window.location.href);
    } else {
        // KRN：根据url中env或者一码多投H5的域名来进行判断
        const { env, degradeWebUrl } = getAppProps();
        // 1.如果拼接了dev，已拼接的为最高优先级
        if (env) return env;
        // 2.通过
        if (degradeWebUrl) return getEnvByUrl(degradeWebUrl);
        // 3.默认线上
        return 'prod';
    }
}

// 获取线上域名，由于线上有AZ域名，所以域名不能写死
export function getProdDomin() {
    // web
    if (Platform.OS === 'web') return location.hostname;
    // krn从一码多投H5上面获取域名
    const { degradeWebUrl } = getAppProps();
    if (degradeWebUrl) {
        // 一码多投域名
        const hostname = new URI(degradeWebUrl).hostname();
        return hostname;
    } else {
        // ikwai域名
        return 'm-shop.kwai.com';
    }
}

// 老H5 domain
export const getDomain = () => {
    const prodDomain = `https://${getProdDomin()}`;
    const prtDomain = 'https://m-shop.prt.kuaishou.com';
    const stagingDomain = 'https://m-shop.staging.kuaishou.com';
    const devDomain = '';

    const runtimeEnv = getEnv();
    if (runtimeEnv === 'prod') return prodDomain;
    if (runtimeEnv === 'prt') return prtDomain;
    if (runtimeEnv === 'staging') return stagingDomain;
    if (runtimeEnv === 'dev') return devDomain;
    return prodDomain;
};

// krn domain
export const getKrnDomain = (env?: string) => {
    const prodDomain = `https://${getProdDomin()}`;
    const prtDomain = 'https://m-shop-krn.prt.kuaishou.com';
    const stagingDomain = 'https://m-shop-krn.staging.kuaishou.com';
    const devDomain = '';

    const runtimeEnv = env || getEnv();
    if (runtimeEnv === 'prod') return prodDomain;
    if (runtimeEnv === 'prt') return prtDomain;
    if (runtimeEnv === 'staging') return stagingDomain;
    if (runtimeEnv === 'dev') return devDomain;
    return prodDomain;
};

export const api = (path: string) => {
    // 如果是一码多投h5直接返回页面的domain，避免域名逃生降级的页面域名和api的域名不一致，导致跨域问题
    if (Platform.OS === 'web' && getEnv() !== 'dev') {
        return `https://${location.hostname}${path}`;
    }

    const _api = getKrnDomain() + path;
    console.log('api full path: ', _api);
    return _api;
};

export interface IResp<T = any> {
    result: number;
    data: T;
    message: string;
}
